import React from "react";
import { func, oneOfType, number, string, bool } from "prop-types";
import { Button, Modal, Alert } from "react-bootstrap";
import warningIcon from "../../../resources/images/warning@3x.png";

const DeleteCandidate = ({
  changeAction,
  currentCandidateId,
  onDeleteCandidate,
  candidateStageId,
  jobId,
  placedAt,
  handleFinishCandidateProfileAction,
}) => {
  const handleChangeAction = () => {
    changeAction(false);
  };

  const handleDeleteCandidate = () => {
    onDeleteCandidate(jobId, candidateStageId, currentCandidateId, placedAt);
    changeAction(false);
    if (handleFinishCandidateProfileAction) {
      handleFinishCandidateProfileAction();
    }
  };

  return (
    <div>
      <Modal.Header>
        <h4>Delete Candidate</h4>
      </Modal.Header>
      <Modal.Body>
        <p>
          When you delete a candidate, all the information about the candidate
          will be removed.
          <br />
          Are you sure you want to delete this candidate?
        </p>
        <Alert variant="danger" className="text-left">
          <img
            src={warningIcon}
            height="16px"
            alt="warning"
            className="mr-2"
            style={{ position: "relative", bottom: "2px" }}
          />
          <span>You can&#39;t undo this action.</span>
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleChangeAction}
          id="cancelDeleteCandidate"
          variant="outline-primary"
          className="btn-cancel"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleDeleteCandidate}
          id="deleteCandidate"
        >
          Delete Candidate
        </Button>
      </Modal.Footer>
    </div>
  );
};

DeleteCandidate.propTypes = {
  changeAction: func,
  currentCandidateId: oneOfType([string, bool]),
  onDeleteCandidate: func,
  candidateStageId: number,
  jobId: string,
  placedAt: string,
  handleFinishCandidateProfileAction: func,
};

export default DeleteCandidate;
